import React from 'react';
import { CTAButton } from './CTAButton';
import { MockupImage } from './MockupImage';
import { TrustLine } from './TrustLine';
import { OFFER_ANCHOR, PRODUCT, PRODUCT_TAGLINE } from '../data/constants';
export function FinalCTA() {
  return <section className="border-t-4 border-diag bg-white py-6 sm:py-9" data-id="element-43" data-mp="c83odh06bg3y">
      <div className="mx-auto max-w-[1080px] px-4 sm:px-6" data-id="element-44" data-mp="844a752d8tdr">
        <h2 className="text-center text-[23px] leading-none text-navy sm:text-[36px]" data-id="element-45" data-mp="m4yjrr15h0e0">
          One last <span className="text-diag" data-id="element-46" data-mp="h5vgab0tj285">question</span>
        </h2>
        <p className="mx-auto mt-2.5 max-w-[800px] text-center text-[14px] font-medium leading-snug text-steel sm:text-[17px]" data-id="element-47" data-mp="h5c5rfdhzg45">
          When the next gasoline engine arrives with a misfire, rough idle, no-start
          or loss of power... Do you immediately know what to test first and where to
          go next? Stop jumping between scattered references and replacing parts
          based on guesses. Follow the symptom. Test the system. Verify the cause.{' '}
          <strong className="font-bold text-navy" data-id="element-48" data-mp="2c5g2jv9w8iqo">Diagnose. Test. Confirm.</strong>
        </p>

        <MockupImage className="mt-4" data-id="element-49" data-mp="2h2y779gvobsv" />

        <div className="mt-4 text-center" data-id="element-50" data-mp="2h3zt68zfmipd">
          <p className="font-display text-[20px] font-bold uppercase leading-none text-navy sm:text-[28px]" data-id="element-51" data-mp="2m2b46n1gqz96">
            🔧 {PRODUCT}
          </p>
          <p className="mx-auto mt-1.5 max-w-[680px] text-[12.5px] font-semibold uppercase leading-tight tracking-wide text-steel sm:text-[15px]" data-id="element-52" data-mp="2r38keu2wxj81">
            {PRODUCT_TAGLINE}
          </p>
          <p className="mt-1.5 font-display text-[12px] font-semibold uppercase tracking-[0.12em] text-diag sm:text-[15px]" data-id="element-53" data-mp="3010zbx4q2ouw">
            Understand • Diagnose • Test • Compare • Identify • Verify
          </p>
        </div>

        <div className="mt-4 flex flex-col items-center" data-id="element-54" data-mp="39uhxfdbw6q4d">
          <p className="mb-2.5 font-display text-[16px] font-bold uppercase leading-tight text-navy sm:text-[21px]" data-id="element-55" data-mp="3esjfpw1hules">
            🔥 GET THE COMPLETE SYSTEM TODAY
          </p>
          <CTAButton href={OFFER_ANCHOR} data-id="element-56" data-mp="1jntsjwpbo3ze">⚡ GET GASOLINE ENGINE DIAGNOSTIC PRO™</CTAButton>
          <TrustLine items={['Immediate Access • Digital Delivery', '🛡️ 7-Day Money-Back Guarantee']} data-id="element-57" data-mp="1epiibkv47rgn" />
        </div>
      </div>
    </section>;
}